export const GET_SINGLE_SELECTED_ADMIN_LOCATION_REQ = 'GET_SINGLE_SELECTED_ADMIN_LOCATION_REQ';
export const GET_SINGLE_SELECTED_ADMIN_LOCATION_SUCC = 'GET_SINGLE_SELECTED_ADMIN_LOCATION_SUCC';
export const GET_SINGLE_SELECTED_ADMIN_LOCATION_FAIL = 'GET_SINGLE_SELECTED_ADMIN_LOCATION_FAIL';